import { Observable } from 'rxjs';

export abstract class FormatDateService {
	abstract ready$: Observable<boolean>;
	abstract formatDate$(date: string, format: string): Observable<string>;
	abstract formatDate(date: string, format: string): string;
}
